var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginTestimateIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M20.5 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-17a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#D3F4FF",
  points: "20.5 5 3.5 5 3.5 19 20.5 19"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M18.503 14.503h-5.21v-1.128l2.4-2.523q.887-1.01.887-1.605 0-.48-.21-.733-.21-.25-.61-.251a.76.76 0 0 0-.641.336q-.246.336-.246.838H13.14a2.45 2.45 0 0 1 1.297-2.179 2.83 2.83 0 0 1 1.364-.328q1.21 0 1.864.559.653.558.653 1.605 0 .441-.164.858-.165.418-.51.877t-1.115 1.228l-.964 1.113h2.938zM6.42 8.03q.639 0 1.078.305.44.304.732.99l.569 1.283 1.207-2.484h1.717l-2.11 4.3 1.108 2.479q.263.592.685.68l.188.023.193-.006-.146 1.342q-.17.04-.381.053-.516.03-.841-.12-.326-.15-.627-.53-.302-.381-.677-1.295l-.375-.85L7.416 16.9H5.74l2.198-4.523L6.93 10.08q-.27-.674-1.014-.674l-.38.035L5.5 8.165q.463-.135.92-.135"
}))));
export default SvgPluginTestimateIcon;